let loaderCounter = 0;
const loaderTimeOut = 16000;

import { translate } from '../../Services/translation';
import {
    GENERIC_LOADER_UPDATE
} from '../constants';

const loaderClass = '.generic-loader';
const loaderListId = 'mainGenericLoaderList';
const loaderId = 'mainGenericLoader__';
const loaderInnerData = '<header></header><ul class="list"></ul><footer></footer>';
const infoList = `<div id="${loaderListId}">${loaderInnerData}</div>`;
let loading = null;

export const toggle3dLoader = (loaderState) => {
    const loaderPrefix = 'generic-loader__';
    const loaderClass = 'boxes2';
    const existingLoader = document.querySelector('.' + loaderPrefix + 'wrapper.external');
    if (loaderState && !existingLoader) {
        const wrapperDiv = document.createElement('div');
        wrapperDiv.className = `${loaderPrefix}wrapper external`;
        const loaderDiv = document.createElement('div');
        loaderDiv.className = loaderPrefix + loaderClass;
        wrapperDiv.appendChild(loaderDiv);
        document.body.appendChild(wrapperDiv);
    } else if (!loaderState && existingLoader) {
        setTimeout(() => {
            existingLoader.remove();
        }, 500);
    }
}
export const toggleSpinnerLoader = (loaderState) => {
    const loaderPrefix = 'generic-loader__';
    const loaderClass = 'spinner';
    const existingLoader = document.querySelector('.' + loaderPrefix + 'wrapper.external');
    if (loaderState && !existingLoader?.querySelector('.' + loaderPrefix + loaderClass)) {
        const wrapperDiv = document.createElement('div');
        wrapperDiv.className = `${loaderPrefix}wrapper external`;
        const loaderDiv = document.createElement('div');
        loaderDiv.className = loaderPrefix + loaderClass;
        wrapperDiv.appendChild(loaderDiv);
        document.body.appendChild(wrapperDiv);
    } else if (!loaderState && existingLoader) {
        setTimeout(() => {
            existingLoader.remove();
        }, 500);
    }
}

export const toggleLoader = (visible, type, showText) => (dispatch, getState) => {
    
    const { loaderCounter, showText } = getState().genericLoader;
    let loaderCnt = visible ? loaderCounter + 1 : loaderCounter - 1;
    let timeout = 0;
    if (loaderCnt < 0) {
        loaderCnt = 0;
    }
    if (loaderCnt == 0) {
        timeout = 500;
    }
    setTimeout(() => {
        dispatch({
            type: GENERIC_LOADER_UPDATE,
            payload: {
                isSearching: loaderCnt > 0,
                loaderType: type || 'spinner',
                loaderCounter: loaderCnt,
                showText
            },
    } , timeout)
   
    });
    //dispatch(toggleGenericLoader(visible, type || genericLoaderType, showText));
    return;
};


export const toggleGenericLoaderList = (visible) => (dispatch, getState) => {
   
    if (visible) {
        dispatch({
            type: GENERIC_LOADER_UPDATE,
            payload: {
                showGenericList: visible,
                genericListLoaded: false,
            },
        });
    }
    else {
        dispatch({
            type: GENERIC_LOADER_UPDATE,
            payload: {
                showGenericList: visible,
                genericListItems: [],
                genericListLoaded: true,
            },
        });
    }

    return;
};

// Add item to generic loader list
// {
//      uploadStatus,   // success, error, warning
//      text            // Text to display in list
// }
// Ex:
// item = { uploadStatus: 'success', text: 'test.jpg' }
export const addGenericLoaderListItem = (item) => (dispatch, getState) => {
    const { genericListItems } = getState().genericLoader;

    dispatch({
        type: GENERIC_LOADER_UPDATE,
        payload: {
            genericListItems: [...genericListItems, item],
        },
    });

    return;
};
export const setGenericListLoaded = (visible) => (dispatch, getState) => {
    dispatch({
        type: GENERIC_LOADER_UPDATE,
        payload: {
            genericListLoaded: visible,
        },
    });

    return;
};

// (Update upload status)
export const updateUploadStatus = (status, errorText = '', index) => (dispatch, getState) => {
    const { genericListItems } = getState().genericLoader;

    // Directly update the item at the specified index
    const updatedListItems = [...genericListItems];
    const updatingItem = updatedListItems.find(x => x.uploadFileIndex == index);
    if (updatingItem) {
        updatingItem.uploadStatus = status;
        updatingItem.errorText = errorText || '';
    }
    dispatch({
        type: GENERIC_LOADER_UPDATE,
        payload: {
            genericListItems: updatedListItems,
        },
    });

    return;
};


//export const toggleLoaderList = (toggleState) => (dispatch, getState) => ({
//    type: GENERIC_LOADER_UPDATE,
//    payload: {
//        showGenericList: toggleState,
//    },
//});

export const reloadTimeout = () => (dispatch, getState) => {
    if (loading) {
        clearTimeout(loading);
    }
    loading = setTimeout(() => {
        const timeoutLoaderEl = document.querySelectorAll(loaderClass);
        if (timeoutLoaderEl) {
            timeoutLoaderEl.forEach((el) => {
                if (el?.classList.contains('active')) {
                    el?.classList.add('timeout');
                }
                el?.classList.remove('active');
            });
        }
    }, loaderTimeOut);
};

export const handleGenericLoaderList = (type = 'activate', htmlToAppend = '', indx = -1, loaderEl) => () => {
    if (!loaderEl) {
        loaderEl = document.getElementById(loaderId + 'spinner');
    }
    let loaderListEl = document.getElementById(loaderListId);
    if (!loaderListEl) {
        loaderEl.append(infoList);
        loaderListEl = document.getElementById(loaderListId);
    }
    const headerEl = loaderListEl.querySelector('header');
    const footerEl = loaderListEl.querySelector('footer');
    const listEl = loaderListEl.querySelector('ul.list');


    //_innerHtml += infoList;
    switch (type) {
        case 'activate':
            loaderListEl.classList.add('active');
            break;
        case 'deactivate':
            loaderListEl.classList.remove('active');
            listEl.innerHTML = '';
            headerEl.innerHTML = '';
            footerEl.innerHTML = '';
            break;
        case 'addToList':
            listEl.innerHTML = htmlToAppend;
            break;
        case 'updateList':
            //indx
            const tempEl = listEl.querySelector(`.loader-item--${indx}`);
            tempEl.innerHTML = htmlToAppend;
            break;
        case 'updateHeader':
            headerEl.innerHTML = htmlToAppend;
            break;
        case 'updateFooter':
            footerEl.innerHTML = htmlToAppend;
            break;
        default:
            break;
    }


    return true;
};

export const toggleGenericLoader = (visible, type = 'spinner', showText = false, activateList) => () => {
    // type = 'ripple' or 'spinner'
    const allLoaderEl = document.querySelectorAll('.generic-loader');
    if (allLoaderEl) {
        allLoaderEl.forEach((el) => {
            if (el?.classList.contains('active')) {
                if (el?.classList.contains('generic-loader__ripple')) {
                    type = 'ripple';
                }
                else {
                    type = 'spinner';
                }
            }
        });
    }

    // Check active loader type
    let loaderEl = document.getElementById(loaderId + type);


    const timedOut = `<span class="timed-out">${translate('common.timeouttext')}</span>`;

    if (!loaderEl) {
        loaderEl = document.createElement('div');
        loaderEl.id = loaderId + type;
        loaderEl.classList = 'generic-loader generic-loader__' + type;

        let _innerHtml = '';
        if (type === 'ripple') {
            _innerHtml += `<div><div></div><div></div></div>`;
        }

        if (showText) {
            _innerHtml += `<span class="loading-text">${translate('common.loadingtext')}</span>`;
        }

        _innerHtml += timedOut;

        loaderEl.innerHTML = _innerHtml;

        document.querySelector('body').append(loaderEl);
    }

    if (type != 'ripple' && activateList) {
        handleGenericLoaderList('activate', '');
    }
    // Handle multiple calls
    if (visible) {
        loaderCounter++;
    } else {
        loaderCounter--;
        if (loaderCounter < 0) loaderCounter = 0;
    }

    if (visible && loaderEl?.classList.contains('active')) {
        return;
    }

    if (loaderEl) {
        if (loaderCounter < 1) {
            if (allLoaderEl) {
                allLoaderEl.forEach((el) => {
                    el?.classList.remove('active');
                    el?.classList.remove('timeout');
                });
            }
            clearTimeout(loading);
            return;
        }
        if (visible) {
            loaderEl.classList.add('active');
            reloadTimeout();

        } else if (loaderCounter < 1) {
            setTimeout(() => {
                loaderEl.classList.remove('active');
                if (type != 'ripple') {
                    handleGenericLoaderList('deactivate', '');
                }
            }, 500); 
        }
    }
    return true;
};
